<template>
  <div class="tw:flex tw:items-center tw:gap-3">
    <Transition name="button-shrink">
      <EdroneButton
        v-if="!isFirstStep"
        type="outline"
        size="big"
        unique-id="tour-prev-btn"
        class="tw:flex-1 tw:hover:scale-[1.02] tw:transition-transform"
        @click="$emit('prev')"
      >
        <template #left-icon>
          <font-awesome-icon icon="fa-light fa-arrow-left" />
        </template>
        {{ trans._onboarding.tour.buttons.prev }}
      </EdroneButton>
    </Transition>

    <Transition name="button-grow" mode="out-in">
      <EdroneButton
        v-if="!isLastStep"
        key="next"
        size="big"
        unique-id="tour-next-btn"
        class="tw:flex-[2] tw:hover:scale-[1.02] tw:transition-transform"
        @click="$emit('next')"
      >
        {{ trans._onboarding.tour.buttons.next }}
        <template #right-icon>
          <font-awesome-icon icon="fa-light fa-arrow-right" />
        </template>
      </EdroneButton>

      <EdroneButton
        v-else
        key="finish"
        size="big"
        unique-id="tour-finish-btn"
        class="tw:flex-[2] tw:hover:scale-[1.02] tw:transition-transform"
        @click="$emit('finish')"
      >
        <template #left-icon>
          <font-awesome-icon icon="fa-light fa-party-horn" />
        </template>
        {{ trans._onboarding.tour.buttons.finish }}
      </EdroneButton>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import EdroneButton from "edrone-components/EdroneButton.vue";

const trans = window._trans;

defineProps<{
  isFirstStep: boolean;
  isLastStep: boolean;
}>();

defineEmits<{
  (e: "prev"): void;
  (e: "next"): void;
  (e: "finish"): void;
}>();
</script>

<style scoped>
.button-shrink-enter-active,
.button-shrink-leave-active {
  transition-property: flex, opacity, min-width, padding;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  overflow: hidden;
}

.button-shrink-enter-from {
  opacity: 0;
  flex: 0 !important;
  padding-left: 0;
  padding-right: 0;
  min-width: 0;
}

.button-shrink-leave-to {
  opacity: 0;
  flex: 0 !important;
  padding-left: 0;
  padding-right: 0;
  min-width: 0;
}

.button-grow-enter-active,
.button-grow-leave-active {
  transition: opacity 0.2s ease;
}

.button-grow-enter-from {
  opacity: 0;
}

.button-grow-leave-to {
  opacity: 0;
}
</style>
